import {Box, Table, TableBody, TableCell, TableRow, Tooltip, Typography} from "@mui/material"
import React from "react"

import {TransactionIcon} from "./TransactionIcon"

import {Transaction} from "@indebted/api"

function List({Transactions}: {Transactions: Transaction[]}) {
	return (
		<Box sx={{width: "100%"}}>
			<Table>
				<TableBody>
					{Transactions.map(({Amount, Date, Time, Type, Description}, index) => (
						<TableRow key={index}>
							<TableCell>
								<Box display="flex">
									<TransactionIcon type={Type} />
									<Typography variant="body2">{Description}</Typography>
								</Box>
							</TableCell>
							<TableCell>
								<Box display="flex" justifyContent="end">
									<Box mr={2}>
										<Tooltip title={Time} placement="left">
											<Typography variant="caption" color="textSecondary">
												{Date}
											</Typography>
										</Tooltip>
									</Box>
									<Typography variant="body2">{Amount}</Typography>
								</Box>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Box>
	)
}

export {List}
